import React, { useState, useEffect } from 'react';
import './HeroSection.css';

function HeroSection() {
  const [searchQuery, setSearchQuery] = useState('');
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const heroImages = [
    'https://www.ng.tzembassy.go.tz/images/gallery/Zanzibar-Island.jpg',
    'https://www.at.tzembassy.go.tz/images/uploads/safari_in_serengeti.jpg',
    'https://text.tzuk.org.uk/wp-content/uploads/2022/11/mount-kilimanjaro-mountain-safari-1025146-1024x658.jpg'
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        (prevIndex + 1) % heroImages.length
      );
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, [heroImages.length]);

  const scrollToNextSection = () => {
    const welcomeSection = document.querySelector('.welcome-section');
    if (welcomeSection) {
      welcomeSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <section className="hero-section">
      {heroImages.map((image, index) => (
        <div 
          key={index} 
          className={`hero-background ${
            index === currentImageIndex ? 'active' : ''
          }`}
          style={{ backgroundImage: `url(${image})` }}
        ></div>
      ))}
      
      <div className="hero-content">
        <h1 className="hero-title">
          Discover story-worthy travel moments with Digital Dream Safaris
        </h1>
        
        <div className="hero-search">
          <input 
            type="text" 
            placeholder="Search destinations, tours, experiences" 
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button>
            SEARCH 
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              width="24" 
              height="24" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <path d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>

      <div 
        className="scroll-down" 
        onClick={scrollToNextSection}
        role="button"
        aria-label="Scroll to next section"
      >
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          width="40" 
          height="40" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        >
          <path d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </div>
    </section>
  );
}

export default HeroSection;
